import client_lookups from '@/assets/json/clientLookups.json'
import { defineStore } from 'pinia'
import { useLookupsStore } from './lookups'
import axiosInstance from '@/services'
import { DateTime } from 'luxon'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'
import client_config from '@/assets/json/client_config.json'

export const useFileValidityStore = defineStore('fileValidity', {
  state: () => {
    return {
      countries: [],
      submittedValues: {},
      result: {},
      oldFiles: []
    }
  },
  getters: {
    isFileExpired() {
      if (Object.keys(this.result).length === 0) {
        return
      }

      const { expireDate } = this.result
      if (!expireDate) return

      const dateLxn = DateTime.fromISO(expireDate)
      const now = DateTime.now()

      return dateLxn < now
    },
    // showVisaExtensionButton() {
    //   if (Object.keys(this.result).length === 0) {
    //     return
    //   }

    //   const {
    //     serviceStatus: { Used }
    //   } = client_lookups

    //   return this.result.serviceStatusId === Used
    // },
    // showEnablePreExtendVisaSection() {
    //   if (Object.keys(this.result).length === 0) {
    //     return
    //   }

    //   const {
    //     serviceStatus: { Active }
    //   } = client_lookups

    //   return this.result.serviceStatusId === Active
    // }
    // aka inquiryAboutIDN
    isInquiryAboutIdNumber() {
      return this.submittedValues.fileModuleId === 3
    },

    isApplicableForVisaSummary() {
      if (Object.keys(this.result).length === 0) {
        return false
      }

      const { enableNewEnhancedVisaDetailsSummary } = client_config

      const {
        module: { visa },
        fileServiceCode: { fiveYearTouristVisa },
        codeVisaStatus
      } = client_lookups

      const { fileServiceCode, fileModuleId, serviceStatusId } = this.result
      const isFileModuleVisa = fileModuleId == visa

      return (
        isFileModuleVisa &&
        fileServiceCode == fiveYearTouristVisa &&
        enableNewEnhancedVisaDetailsSummary &&
        Object.values(codeVisaStatus).includes(serviceStatusId)
      )
    },
    // aka checkApplicabilityDetailsForFiveYearsTouristVisa
    isApplicableForFiveYearTouristVisa() {
      if (Object.keys(this.result).length === 0) {
        return false
      }

      const { enableFiveYearsTouristVisaDetails } = client_config

      const {
        serviceStatus: { Used, Closed },
        fileServiceCode: { fiveYearTouristVisa }
      } = client_lookups

      const { fileServiceCode, serviceStatusId } = this.result

      const isUsedOrClosed = [Used, Closed].includes(serviceStatusId)

      return (
        fileServiceCode == fiveYearTouristVisa &&
        enableFiveYearsTouristVisaDetails &&
        isUsedOrClosed
      )
    },
    showResidencyStayingDays() {
      if (Object.keys(this.result).length === 0) {
        return false
      }

      const { totalResiStayingDays, cancelDate, serviceStatusId, hideNumberOfRemainingDays } =
        this.result

      return (
        totalResiStayingDays > 0 &&
        (cancelDate || this.isFileExpired || [3, 4, 15, 16, 17].includes(serviceStatusId)) &&
        !hideNumberOfRemainingDays
      )
    },
    showEnablePreExtendVisaSection() {
      if (Object.keys(this.result).length === 0) {
        return false
      }

      const {
        serviceStatus: { Active }
      } = client_lookups
      const { serviceStatusId } = this.result

      return serviceStatusId == Active
    },
    showEnableExtendVisaSection() {
      if (Object.keys(this.result).length === 0) {
        return false
      }

      const {
        serviceStatus: { Used }
      } = client_lookups
      const { serviceStatusId } = this.result

      return serviceStatusId == Used
    },
    oldFilesAsDatatable() {
      if (this.oldFiles.length === 0) return

      return this.oldFiles.map((o) => {
        return {
          ...o,
          issueDate: DateTime.fromISO(o.issueDate).toFormat('dd/MM/yyyy'),
          cancellationOrCloseDate: DateTime.fromISO(o.cancellationOrCloseDate).toFormat(
            'dd/MM/yyyy'
          )
        }
      })
    }
  },
  actions: {
    async fetchCountries() {
      const lookupsStore = useLookupsStore()
      const response = await lookupsStore.fetchLookup('/api/lookup/countries/exceptGccForEida')

      this.countries = response
    },
    resetFileTypeFields(resetField) {
      resetField('serviceCode')
    },
    async submitRequest(form) {
      if (!form.recaptchaResponse) {
        notify(
          {
            group: 'error',
            title: i18n.global.t('captchaNotProcessed')
          },
          6000
        )
        return
      }

      const body = {
        ...form,
        isUsingCaptcha: true
      }

      this.submittedValues = body

      body.dateOfBirth = DateTime.fromFormat(form.dateOfBirth, 'yyyy-MM-dd', 'yyyy/MM/dd')

      const response = await axiosInstance.post('/api/landing/fileValidityNew', body)

      if (response?.noDataFound) {
        notify(
          {
            group: 'warning',
            text: i18n.global.t('noDataFoundMessage')
          },
          6000
        )
        return
      }

      const {
        fileValidity,
        response: { item1: oldFiles, item2, item3, item4 }
      } = response

      /**
       * DEV NOTE:
       * items 2, 3, and 4 are still pending.
       * Once we have more sample data, we'll continue development/
       *
       * /client/shared/pages/fileValidity/fileValidityCtrl.js
       * // call the function to get summery of visa
       */

      if (fileValidity && fileValidity.serviceStatus) {
        const { fileServiceYear, fileSequenceNumber, fileDepartmentCode, fileServiceCode } =
          fileValidity
        this.result = {
          ...fileValidity,
          fileNumberFull: [
            fileDepartmentCode,
            fileServiceYear,
            fileServiceCode,
            fileSequenceNumber
          ].join(' / ')
        }
      }

      this.oldFiles = oldFiles
    }
  }
})
